import { CALC_PAGE_TYPES } from 'utils/calculatorUtils';
import Results from '../../CommonViews/Results';

const Reports = ({ targetWidth }) => (
  <Results targetWidth={targetWidth} pageType={CALC_PAGE_TYPES.CUSTOM} />
);

export default Reports;
